import {AbstractError} from "./AbstractError";

export class RequestError extends AbstractError {}
export class InvalidTypeError extends RequestError {}
export class InvalidMethodError extends RequestError {}